import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../../custom/BackButton';
import ActionIcon from '../../custom/ActionIcon';
import { createdUpdatedInfo } from '../../../utils';
import { IFFM, SelectOption, ISpecialHandlingCode } from '../../../globals/interfaces';
import VirtualTable from '../../custom/VirtualTable';
import { FormGroup } from 'reactstrap';
import SpecialHandlingCodes from '../../custom/SpecialHandlingCodes';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    mawbSummaryFFMs: Array<IFFM>;
    shcs: Array<ISpecialHandlingCode>;
    selectedShcs: Array<SelectOption>;
    setSelectedShcs: React.Dispatch<React.SetStateAction<Array<SelectOption>>>;
    handleBreakdownInstructionsMawbSummaryUpdateShc: () => Promise<void>;
    loadingMawbSummary: boolean;
}

export default function ModalMawbsSummary ({
    modal,
    setModal,
    mawbSummaryFFMs,
    shcs,
    selectedShcs,
    setSelectedShcs,
    handleBreakdownInstructionsMawbSummaryUpdateShc,
    loadingMawbSummary
}: Props) {

    const toggle = () => setModal(!modal);

    if (!mawbSummaryFFMs || !mawbSummaryFFMs.length) return null;

    const { s_mawb, s_flight_id } = mawbSummaryFFMs[0];

    return (
        <CustomModal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Flight ID {s_flight_id} and MAWB {s_mawb}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <VirtualTable<IFFM> 
                    data={mawbSummaryFFMs}
                    mapping={[{
                        name: 'ULD',
                        value: 's_uld',
                        customWidth: 200
                    }, {
                        name: 'ORI/POL/POU/DES',
                        value: 'b_breakdown_hawb',
                        concat: true,
                        values: ['s_origin', 's_pol', 's_pol', 's_destination'],
                        operator: '/',
                        customWidth: 170
                    }, {
                        name: 'Pieces',
                        value: 'i_actual_piece_count',
                        number: true,
                        customWidth: 75
                    }, {
                        name: 'Kilos',
                        value: 'f_weight',
                        number: true,
                        customWidth: 75
                    }, {
                        name: 'Commodity',
                        value: 's_commodity'
                    }, {
                        name: 'Special Handling Code',
                        value: 's_special_handling_code'
                    }]}
                    numRows={10}
                />
                <FormGroup className={'mt-4'}>
                    <Label>Update All Special Handling Codes</Label>
                    <SpecialHandlingCodes 
                        shcs={shcs}
                        selectedShcs={selectedShcs}
                        setSelectedShcs={setSelectedShcs}
                    />
                </FormGroup>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={() => handleBreakdownInstructionsMawbSummaryUpdateShc()} 
                            loading={loadingMawbSummary}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </CustomModal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const CustomModal = styled(Modal)`
    max-width: 1200px;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;